export function dateToTimeString(date: Date) {
    const str = date.toLocaleString().replace(/-/g, '/').replace('T', ' ').replace('.', ' ').replace('Z', '');
    return `${str} ${date.getMilliseconds()}`;
}
